import React, { useState } from 'react';
import './MakoRX.css';

const MakoRX = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="makorx-container">
            <h1 className="makorx-title">Mako RX</h1>

            {/* Link Box */}
            <a href="https://powerforms.docusign.net/5a8c4692-065b-460f-83b9-a80ec05a9eba?env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&accountId=e6b74557-3473-4b9f-856e-4ebef6b2b3c7" target="_blank" rel="noopener noreferrer" className="makorx-box">
                <div className="makorx-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="makorx-faq-section">
                <h2 className="makorx-faq-title">Frequently Asked Questions</h2>
                <div className="makorx-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`makorx-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="makorx-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="makorx-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`makorx-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MakoRX;